<template>
  <generic-container
    :title="$t('modules')"
    icon="boxes"
    :header_buttons="header_buttons"
  >
    <table
      class="ui celled very compact selectable striped table"
      ref="module_access"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("module") }}</th>
          <th>{{ $t("granted") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(mdle, index) in modules" :key="index">
          <td>{{ $t(mdle.setup.name) }}</td>
          <td>
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="public"
                v-model="modules[index].granted"
              />
              <label></label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </generic-container>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "ModulManagerConfigureInstanceModulesManager",
  components: {
    GenericContainer
  },
  computed: {},
  props: { modules: Array, instance: Object, enterprise_id: Number },
  data() {
    return {
      loading: true,
      system_modules: [],
      header_buttons: [
        {
          icon: "green check",
          click: this.apply,
          tooltip: this.$t("apply")
        }
      ]
    };
  },
  methods: {
    apply() {
      let vm = this;

      let granted = vm.modules
        .filter((m) => m.granted)
        .map((m) => {
          return m.module_id;
        });

      local_api(vm, "post", "/modul_manager/do-apply-modules", {
        e: vm.enterprise_id,
        m: granted
      })
        .then(() => {
          vm.$alertify.success(vm.$t("modules applied"));
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {}
    });
  },
  updated: function() {},
  created() {
    let vm = this;

    if (vm.instance) {
      vm.uuid = vm.instance.uuid;
    }
  }
};
</script>
